import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {branch} from 'baobab-react/higher-order';

import utils from '@utils';

import Block from '@components/common/block';
import MapMini from '@components/common/map-mini';
import Checkbox from '@components/common/checkbox';
import ZoomSlider from '@components/controls/zoom-slider';

import BLOCKS from '@store/blocks';
import {PARAM_CHANGE} from '@store/actions';
import {ZOOM, GLIDE} from './actions';

import styles from './index.module.css';

import thumbnailTrees from './images/mapTrees.png';
import thumbnailNoTrees from './images/mapNoTrees.png';

import MAP_CONSTANTS from '../../../constants/map.json';

utils.preloadImages([thumbnailTrees, thumbnailNoTrees]);

const DEFAULT_PARAMS = MAP_CONSTANTS.mini;
const SLIDER_ZOOM_VALS = DEFAULT_PARAMS.zoomVals.map((val, idx) => ({ value: idx, label: val.label }));
const SLIDER_ZOOM_ONLY_VALUES = DEFAULT_PARAMS.zoomVals.map((val, idx) => DEFAULT_PARAMS.zoomVals[idx].value);
const sliderZoomToReal = zoom => DEFAULT_PARAMS.zoomVals[zoom].value;
const realZoomToSlider = zoom => SLIDER_ZOOM_ONLY_VALUES.indexOf(zoom);

class MiniMapBlock extends Component {

  constructor(props) {
    super(props);

    this.state = {withTrees: false, withLegends: true};

    this.initHandlers();
  }

  initHandlers() {
    const props = this.props;

    this._onZoom = zoom => props.dispatch(ZOOM, sliderZoomToReal(zoom));
    this._onGlide = props.dispatch.bind(null, GLIDE);
    this._onTreeCheck = props.dispatch.bind(this, PARAM_CHANGE, BLOCKS.MINI_MAP.WITH_TREES);
    this._onLegendCheck = props.dispatch.bind(this, PARAM_CHANGE, BLOCKS.MINI_MAP.WITH_LEGENDS);
  }

  render() {
    const props = this.props;

    return (
      <Block className={styles.block} header='Map Controls'>
        {props.visReconStep > -1 && <div className={styles.backdrop} />}
        <div className={styles.content}>
          When zoomed in, click and drag to navigate:
        </div>
        <MapMini
          zoom={props.zoom}
          offset={props.offset}
          onGlide={this._onGlide}
          width={DEFAULT_PARAMS.mapWidth}
          height={DEFAULT_PARAMS.mapHeight}
          bitmap={props.withTrees ? thumbnailTrees : thumbnailNoTrees}/>
        <ZoomSlider
          model={realZoomToSlider(props.zoom)}
          onChange={this._onZoom}
          settings={{
            width: 100,
            precision: 1,
            color: '#9D9D9D',
            handleColor: '#F5F2F2',
            backgroundColor: '#fff',
            vals: SLIDER_ZOOM_VALS,//DEFAULT_PARAMS.zoomVals,
            initialValue: SLIDER_ZOOM_VALS[0].value,//DEFAULT_PARAMS.zoomVals[0].value,
            outerStyle: { marginTop: '12px' }
          }} />
        <div className={styles.labels}>
          <label className={styles.label}>
            <Checkbox
              value={props.withTrees}
              onChange={this._onTreeCheck}/>
            Show Trees
          </label><label className={styles.label}>
            <Checkbox
              value={props.withLegends}
              onChange={this._onLegendCheck}/>
            Show Legend
          </label>
        </div>
      </Block>);
  }
}

MiniMapBlock.defaultProps = {
  withTrees: false,
  withLegends: false
};

MiniMapBlock.propTypes = {
  zoom: PropTypes.number.isRequired,
  offset: PropTypes.object.isRequired,
  withTrees: PropTypes.bool,
  withLegends: PropTypes.bool,
  visReconStep: PropTypes.number.isRequired
};

export default branch({
  offset: BLOCKS.MAP.OFFSET,
  zoom: BLOCKS.MINI_MAP.ZOOM,
  withTrees: BLOCKS.MINI_MAP.WITH_TREES,
  withLegends: BLOCKS.MINI_MAP.WITH_LEGENDS,
  visReconStep: BLOCKS.RECON_PANELS.CURRENT_STEP
}, MiniMapBlock);